module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ashou6-a67f9c2595d95cb200e2d4f667059d3f.jpg";